<nav class="navbar">
  <div class="navbar__logo">
    <img src="assets/img/logo/logo-endoso-powerpay-white.svg" alt="Logo Powerpay" />
  </div>

  <div class="navbar__help" (click)="onClickMenu()">
    <button type="button">
      <img [src]="menuIcon" alt="Menú ayuda" />
    </button>
  </div>
</nav>
